import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import { Page, BlockStack, Card, Text, PageActions, ButtonGroup, Button, Box } from '@shopify/polaris';
import { ArrowRightIcon } from '@shopify/polaris-icons';
import logo from '#client/assets/images/ww-logo-allcompany-black.png';
import CustomerAuthButton from '#client/components/common/CustomerAuthButton/CustomerAuthButton';

import './Home.css';

const Home = () => {
    const { isAuthenticated } = useContext(SessionContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated]);

    const handleAdminLogin = () => {
        window.location.href = `${import.meta.env.VITE_API_URL}/auth/admin?shop=${import.meta.env.VITE_SHOPIFY_STORE}`;
    };

    return (
        <Box className="login">
            <Box className="login-info">
                <Page>
                    <Box className="logo">
                        <img src={logo} alt="Work World App" />
                    </Box>
                    <Card>
                        <BlockStack gap="300">
                            <Box className="login-info">
                                <Text variant="headingMd" as="h2">
                                    Corporate Voucher Program Administration
                                </Text>
                                <Text as="p">Login to administrate Voucher Programs</Text>

                                <ButtonGroup>
                                    <CustomerAuthButton>Login with Shopify</CustomerAuthButton>
                                </ButtonGroup>
                            </Box>
                        </BlockStack>
                    </Card>
                    <PageActions
                        primaryAction={
                            <Button onClick={handleAdminLogin} variant="tertiary" icon={ArrowRightIcon}>
                                Work World Staff Login
                            </Button>
                        }
                    />
                </Page>
            </Box>
        </Box>
    );
};

export default Home;
